/* Keep the product page price in step with the chosen variant.

   The theme already swaps the variant correctly: picking 1KG rewrites the URL
   and the hidden input[name=id], so the right thing reaches the cart. What it
   does not do is repaint the price, so a 1KG bag at $55.00 sat under a
   $17.50 label. The variant list is already printed on the page as JSON by
   <variant-selects>, so the price is read from there rather than fetched.

   The money format is taken from whatever the page rendered first, so the
   store's own currency symbol and suffix survive instead of being guessed. */
(function () {
  function money(el, cents) {
    if (el.dataset.cappaFmt === undefined) {
      /* Only the first price and its currency code: the compare-at price
         and the -% badge that follow it must not leak into the suffix. */
      var m = (el.textContent || '').trim().match(/^([^\d]*)([\d.,]+)(\s*[A-Z]{3})?/);
      el.dataset.cappaFmt = m ? JSON.stringify([m[1], m[3] || '']) : JSON.stringify(['$', '']);
    }
    var parts = JSON.parse(el.dataset.cappaFmt);
    return parts[0] + (cents / 100).toFixed(2) + parts[1];
  }

  function wire(vs) {
    if (vs.hasAttribute('data-cappa-price')) return;
    var tag = vs.querySelector('script[type="application/json"]');
    if (!tag) return;
    var variants;
    try { variants = JSON.parse(tag.textContent); } catch (e) { return; }
    vs.setAttribute('data-cappa-price', '');

    var section = vs.getAttribute('data-section');
    var scope = vs.closest('.pdp-summery') || vs.closest('.product-main-section') || document;

    function apply() {
      var picked = Array.prototype.map.call(vs.querySelectorAll('select'), function (s) { return s.value; });
      var v = null;
      for (var i = 0; i < variants.length; i++) {
        var ok = true;
        for (var j = 0; j < picked.length; j++) {
          if (variants[i].options[j] !== picked[j]) { ok = false; break; }
        }
        if (ok) { v = variants[i]; break; }
      }
      if (!v) return;

      var targets = document.querySelectorAll(
        section ? '#price-' + CSS.escape(section) + ', .sticky-price' : '.pdp-summery .price'
      );
      Array.prototype.forEach.call(targets, function (el) {
        var out = money(el, v.price);
        el.textContent = '';
        var reg = document.createElement('ins');
        reg.className = 'price-item--regular';
        reg.textContent = out;
        el.appendChild(reg);
        if (v.compare_at_price && v.compare_at_price > v.price) {
          var was = document.createElement('ins');
          was.className = 'price-item--sale';
          was.textContent = money(el, v.compare_at_price);
          el.appendChild(was);
          var b = document.createElement('span');
          b.className = 'cappa-save-badge';
          b.setAttribute('style', 'display:inline-block;margin-left:10px;padding:3px 9px;border-radius:999px;background:#c0392b;color:#fff;font-size:13px;font-weight:700;line-height:1.4;vertical-align:middle;');
          b.textContent = '-' + Math.round((v.compare_at_price - v.price) * 100 / v.compare_at_price) + '%';
          el.appendChild(b);
        }
      });

      var btn = scope.querySelector ? scope.querySelector('.product-form__submit') : null;
      if (btn) {
        btn.disabled = !v.available;
      }
    }

    /* Name each dropdown. Two unlabelled boxes reading "250g" and "Whole
       Beans" gave no clue that they were Size and Grind. */
    Array.prototype.forEach.call(vs.querySelectorAll('select'), function (s) {
      if (s.previousElementSibling && s.previousElementSibling.classList.contains('cappa-optlabel')) return;
      var m = (s.getAttribute('name') || '').match(/options\[(.+)\]/);
      if (!m) return;
      var lab = document.createElement('span');
      lab.className = 'cappa-optlabel';
      lab.textContent = m[1];
      s.parentNode.insertBefore(lab, s);
    });

    vs.addEventListener('change', function () { setTimeout(apply, 0); });
    apply();
  }

  function scan() {
    document.querySelectorAll('.pdp-summery variant-selects, .product-main-section variant-selects').forEach(wire);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', scan);
  } else {
    scan();
  }
  window.addEventListener('load', scan);
})();
